module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img1.09f6f071.png";